import { tlwTwMerge } from '@trg/utils';
import { Tag } from '@trg/tlw-ui-component';
import { useProductCardContext } from './ProductCardContext';
import type { HTMLAttributes } from 'react';

export type ProductCardTagsProps = Omit<
  HTMLAttributes<HTMLDivElement>,
  'children'
>;

export function ProductCardTags({ className, ...props }: ProductCardTagsProps) {
  const { product } = useProductCardContext();

  return (
    <div
      className={tlwTwMerge(
        'tlw-flex tlw-flex-wrap tlw-gap-x-2 tlw-gap-y-1',
        className
      )}
      {...props}
    >
      {product.otherTag?.map((item) => (
        <Tag key={item}>{item}</Tag>
      ))}
    </div>
  );
}
